import React, { memo, useContext } from 'react';
import Markdown from '../../../components/shared/Markdown';
import { safetyCheck } from '../../../utils';
import PageContext from '../../../contexts/PageContext';

const CharacterA = () => {
    const { data, heading: Heading } = useContext( PageContext );

    return (
        safetyCheck( data.character, 'body' ) && (
            <div>
                <Heading>{data.character.heading}</Heading>
                <Markdown className="markdown text-sm">{data.character.body}</Markdown>
            </div>
        )
    );
};

export default memo( CharacterA );
